import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import i18n from '../../i18n';
import { Channel as ChannelType, ChannelLogoType, Program as ProgramType, RootState } from '../../interfaces';
import { formatSeasonAndEpisode, formatTimeSpan, getChannelLogoUrl } from '../../utils/tvUtils';
import { DetailsLink } from '../../views/ats-details/details-link';
import { showChannelList as showChannelListAction } from '../../views/tv/actions';
import './style.scss';

interface ActiveChannelProps {
  show: boolean;
  currentChannel: ChannelType;
  currentProgram: ProgramType;
}

export default function ActiveChannel({ show, currentChannel, currentProgram }: ActiveChannelProps) {
  const dispatch = useDispatch();
  const channelListVisible = useSelector((state: RootState) => state.channelsReducer.channelListVisible);

  const showChannelList = useCallback(() => {
    dispatch(showChannelListAction());
  }, [dispatch]);

  if (!show || !currentProgram || channelListVisible) {
    return null;
  }

  const formattedTime = formatTimeSpan(currentProgram.starttime, currentProgram.endtime);
  const seasonAndEpisodeShorthand = formatSeasonAndEpisode(currentProgram.seasonNum, currentProgram.subNum);
  const logoUrl = getChannelLogoUrl(currentChannel, ChannelLogoType.CROPPED);

  return (
    <div className="activeChannel">
      <button className="showChannelListButton" onClick={showChannelList}>
        <span className="arrowUp">u</span>&nbsp;
        {i18n.t<string>('choose channel')}
      </button>
      <div>
        <button className="showChannelListLogoButton" onClick={showChannelList}>
          {logoUrl ? <img src={logoUrl} alt={i18n.t<string>('choose channel')} /> : currentChannel.name}
        </button>
        <DetailsLink className="activeProgram" type="program" id={currentProgram.id}>
          <div>{formattedTime}</div>
          <div className="nameSeasonAndEpisode">
            <div className={'programName'}>{currentProgram.name}</div>
            {seasonAndEpisodeShorthand && <div className={'seasonAndEpisode'}>&nbsp;- {seasonAndEpisodeShorthand}</div>}
          </div>
        </DetailsLink>
      </div>
    </div>
  );
}
